export const CONVERSIONS_REPORT_ID = 'conversions';
